import { Group, Skeleton, Stack } from "@mantine/core";

type Props = {
  count: number;
};

function LoadingPillItems({ count }: Props) {
  return (
    <Stack>
      <Group>
        {Array.from(Array(count), (_, i) => (
          <Skeleton w={70} radius={10} height={30} key={i} />
        ))}
      </Group>
    </Stack>
  );
}

export default LoadingPillItems;
